/* @refresh reload */
import { render } from 'solid-js/web'
import { lazy, type ParentProps } from 'solid-js'
import { Router, Route, useBeforeLeave } from '@solidjs/router'
import App from './App.tsx'
import './index.css'

const Message = lazy(async () => {
  const [{ QueryClient, QueryClientProvider }, mod] = await Promise.all([
    import('@tanstack/solid-query'),
    import('./routes/Message.tsx'),
  ])
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  })
  const Inner = mod.default
  return {
    default: () => (
      <QueryClientProvider client={queryClient}>
        <Inner />
      </QueryClientProvider>
    ),
  }
})
const NotFound = lazy(() => import('./routes/NotFound.tsx'))

function Layout(props: ParentProps) {
  useBeforeLeave((e) => {
    if (e.defaultPrevented) return
    if (typeof document === 'undefined' || !document.startViewTransition) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    if (typeof e.to !== 'string') return

    let toPath: string
    try {
      toPath = new URL(e.to, location.href).pathname
    } catch {
      return
    }
    if (toPath === location.pathname) return

    e.preventDefault()
    const t = document.startViewTransition(() => {
      e.retry(true)
    })
    t.finished.catch(() => {})
  })
  return <>{props.children}</>
}

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')

render(
  () => (
    <Router root={Layout}>
      <Route path="/" component={App} />
      <Route path="/messages" component={Message} />
      <Route path="*" component={NotFound} />
    </Router>
  ),
  root,
)
